import React from "react";
import MdalDataType from "Interface/MdalDataType.interface";
import { useScrollLock } from "Utils/useScrollLock";

import 'Assets/css/Mdal.css';


const MdalCommUi = ({mdalType,mdalSize,mdalFunc,mdalCtxtTitl}:MdalDataType) => {
    
    // 모달이 렌더링되면 자동으로 스크롤 락 적용
    useScrollLock(true);

    return(
        <>
            <div className='mdalCommWrap'>
                <div className='mdalBg' onClick={mdalFunc}></div>
                <div className='mdalCommContainer'>
                    <div className='mdalCommCloseBtn' onClick={mdalFunc}><i className="close"></i></div>
                    <div className="mdalCtxtInfo"
                    dangerouslySetInnerHTML={{
                                        __html: mdalCtxtTitl,
                                    }}>
                    </div>
                    <button className='trmsAgreeBtn' onClick={mdalFunc}>
                        <p>확인</p>
                    </button>
                </div>
            </div>
        </>
    )
}

export default MdalCommUi;